export default [
    // 资源
    {
        path: "/collection",
        name: "collection",
        component: () => import("../views/collection/index.vue"),
    },

    {
        path: "/collection/list",
        name: "collectionList",
        component: () => import("../views/collection/list.vue"),
    },
    {
        path: "/collection/subjectDetail/:id",
        name: "collectionSubjectDetail-Id",
        component: () => import("../views/collection/subjectDetail.vue"),
    },
    {
        path: "/collection/subjectDetail",
        name: "collectionSubjectDetail",
        component: () => import("../views/collection/subjectDetail.vue"),
    },
    {
        path: "/collection/videoDetail/:id",
        name: "collectionVideoDetail",
        component: () => import("../views/collection/videoDetail.vue"),
    },
    {
        path: "/collection/videoPlay",
        name: "collectionVideoPlay",
        component: () => import("../views/collection/videoPlay.vue"),
    },
    {
        path: "/collection/fileShow",
        name: "collectionFileShow",
        component: () => import("../views/collection/videoPlay.vue"),
    },
    {
        path: "/collection/articleDetail/:id",
        name: "collectionArticleDetail",
        component: () => import("../views/collection/articleDetail.vue"),
    },
    {
        path: "/collection/pdfRead",
        name: "collectionPdfRead",
        component: () => import("../views/collection/pdfRead.vue"),
    },
    {
        path: "/collection/moreRead",
        name: "collectionMoreRead",
        component: () => import("../views/collection/moreRead.vue"),
    },
    {
        path: "/collection/advanceSearch",
        name: "collectionAdvanceSearch",
        component: () => import("../views/collection/advanceSearch.vue"),
    },
    {
        path: "/collection/summarize/",
        name: "collectionSummarize",
        component: () => import("../views/collection/summarize.vue"),
    },
    {
        path: "/collection/readUp/:id",
        name: "collection-readUp-id",
        component: () => import("../views/collection/readUp.vue"),
    },
]